import { createTPluginFactory } from '../../plate';
import AnimatedTextLeaf from './components/AnimatedTextLeaf';

export const createAnimatedTextPlugin = createTPluginFactory({
  key: 'animation',
  isLeaf: true,
  component: AnimatedTextLeaf,
});
